import _ from 'lodash';
import uuid from 'uuid/v4';

const TOTAL_ROWS = 12;
const ROWS_AT_END = 3;

const badRE = /[,0-9,"']+/;

class SoundsLikePhraseObject {
  constructor(params) {
    if (_.isEmpty(params)) {
      this.soundsLike = '';
    } else if (_.isString(params)) {
      this.soundsLike = params;
    } else if (_.isObject(params)) {
      this.soundsLike = _.get(params, 'soundsLike');
      this.id = _.get(params, 'id');
    }
  }

  get soundsLike() {
    if (!('_soundsLike' in this)) {
      this._soundsLike = '';
    }
    return this._soundsLike;
  }

  set soundsLike(value) {
    this._soundsLike = _.trim(value, '"');
  }

  get isBad() {
    if (badRE.test(this.soundsLike)) {
      return `Bad char ${badRE.exec(this.soundsLike)[0]}`;
    }
    return false;
  }

  get empty() {
    return !this.soundsLike;
  }


  get id() {
    if (!('_id' in this)) {
      this._id = uuid();
    }
    return this._id;
  }

  set id(value) {
    if (value && _.isString(value)) {
      this._id = value;
    }
  }

  /**
   * this method transforms junk data into an array of soundsLike objects.
   * Note - no redundancy checks are in this code.
   * @param input
   * @returns {*}
   */
  static toList(...input) {
    const cleanList = _(input)
      .flattenDeep()
      .compact()
      .map((kwObject) => {
        if (!(kwObject instanceof SoundsLikePhraseObject)) {
          return new SoundsLikePhraseObject(kwObject);
        }
        return kwObject;
      })
      .reject('empty')
      .value();
    while ((cleanList.length < TOTAL_ROWS)
    || cleanList.slice(-ROWS_AT_END).filter(a => !a.empty).length) {
      cleanList.push(new SoundsLikePhraseObject());
    }
    return cleanList;
  }

  static listToPhrases(...list) {
    return _(list)
      .flattenDeep()
      .compact()
      .reject((item) => {
        if (item instanceof SoundsLikePhraseObject) {
          return item.isBad;
        }
        if (typeof item === 'string') {
          return new SoundsLikePhraseObject(item).isBad;
        }
        return false;
      })
      .map((item) => {
        if (typeof item === 'string') {
          return item;
        } else if (item instanceof SoundsLikePhraseObject) {
          return item.soundsLike;
        } else if (typeof item === 'object') {
          return item.soundsLike;
        }
        return '';
      })
      .compact()
      .uniq()
      .sortBy()
      .value();
  }
}

export default SoundsLikePhraseObject;
